// src/App.js
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import LoadingScreen from './components/LoadingScreen';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/theme.css';
import './styles/cosmic.css';

// Global error handlers for better debugging
// if (typeof window !== 'undefined') {
//   // Catch unhandled errors
//   window.addEventListener('error', (event) => {
//     console.error('[Global Error Handler] Unhandled error:', {
//       message: event.message,
//       filename: event.filename,
//       lineno: event.lineno,
//       colno: event.colno,
//       error: event.error,
//       stack: event.error?.stack,
//     });
//   });
//
//   // Catch unhandled promise rejections
//   window.addEventListener('unhandledrejection', (event) => {
//     console.error('[Global Error Handler] Unhandled promise rejection:', {
//       reason: event.reason,
//       promise: event.promise,
//     });
//   });
// }

/** PageShell wraps routes to provide a global, opaque loader & fade-in */
function PageShell({ children }) {
  const location = useLocation();
  const [loading, setLoading] = React.useState(true);
  const [fadeIn, setFadeIn] = React.useState(false);
  const prevPathRef = React.useRef(location.pathname);

  React.useEffect(() => {
    // If pathname changed, immediately show loader
    if (prevPathRef.current !== location.pathname) {
      setLoading(true);
      setFadeIn(false);
      prevPathRef.current = location.pathname;

      const delay = 800; // Brief loading for smooth transitions
      const t = setTimeout(() => {
        setLoading(false);
        // Trigger fade-in after a brief moment
        setTimeout(() => setFadeIn(true), 50);
      }, delay);

      return () => clearTimeout(t);
    } else {
      // First mount
      const t = setTimeout(() => {
        setLoading(false);
        setTimeout(() => setFadeIn(true), 50);
      }, 800);

      return () => clearTimeout(t);
    }
  }, [location.pathname]);

  if (loading) {
    return <LoadingScreen />;
  }

  return <div className={`page-content ${fadeIn ? 'page-fade-in' : ''}`}>{children}</div>;
}

export default function App() {
  return (
    <ErrorBoundary>
      <PageShell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </PageShell>
    </ErrorBoundary>
  );
}
